import React, { useState, useEffect } from "react";
import { Table } from "@veneer/core";
import "./SpecialConditionDetailStyle.css"



function SpecialCondtionAdditionalInformation({ specialCondition }) {



    let specialConditionArray = [specialCondition];
    return (<>
        <table id="additionalInformationTable">
            <tr>
                <th>Contact Name</th>
                <td>{specialCondition.endUserContactName}</td>
            </tr>
            <tr>
                <th>Contact Phone</th>
                <td>{specialCondition.endUserContactPhone}</td>
            </tr>
            <tr>
                <th>Contact Position</th>
                <td>{specialCondition.endUserContactPosition}</td>
            </tr>
            <tr>
                <th>Justification</th>
                <td>{specialCondition.justification}</td>
            </tr>
            <tr>
                <th>Competition</th>
                <td>{specialCondition.competition}</td>
            </tr>
            <tr>
                <th>Business Opportunities</th>
                <td>{specialCondition.businessOpportunities}</td>
            </tr>
            <tr>
                <th>Volume Growth</th>
                <td>{specialCondition.volumeGrowth}</td>
            </tr>
            <tr>
                <th>Comments</th>
                <td>{specialCondition.comments}</td>
            </tr>
        </table>
    </>);
}

export default SpecialCondtionAdditionalInformation